/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum TyreDelivery {
  NONE = 0,
  PURCHASE = 1,
  TYREHOTEL = 2,
  CUSTOMERBRING = 3,
  CUSTOMERSENDED = 4,
}

export namespace TyreDelivery {
  export function values() {
    return Object.keys(TyreDelivery).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
